import axios from "axios";

// Backend URL resolution:
//   • Preview/dev (host ends in "preview.emergentagent.com"): use REACT_APP_BACKEND_URL
//   • Production deploy (frontend and API are served from the same origin):
//     use a relative "/api" path so requests stay same-origin and avoid
//     cross-origin/cookie issues when the build-time env var doesn't match
//     the actual prod hostname.
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const isPreview =
  typeof window !== "undefined" &&
  window.location.hostname.endsWith("preview.emergentagent.com");
const BACKEND_URL = isPreview ? ENV_BACKEND_URL : "";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---------------------------------------------------------------------------
// Runtime watchdog: catches the "wrong env-var baked into the bundle" class
// of bug. On the first failed API request we log a single, loud diagnostic
// to the browser console explaining exactly what URL was attempted and how
// to fix it. This is silent on success — zero overhead.
// ---------------------------------------------------------------------------
let _watchdogFired = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      !_watchdogFired &&
      typeof window !== "undefined" &&
      // axios sets err.message to "Network Error" on CORS / DNS failures
      err?.message === "Network Error"
    ) {
      _watchdogFired = true;
      const attemptedUrl = err?.config?.baseURL
        ? err.config.baseURL + (err.config.url || "")
        : "(unknown)";
      // eslint-disable-next-line no-console
      console.error(
        "%c[Infinity DMS] API watchdog — Network Error",
        "background:#af3fa6;color:#fff;font-weight:bold;padding:2px 8px;border-radius:4px;",
        "\nAttempted:", attemptedUrl,
        "\nFrontend origin:", window.location.origin,
        "\nLikely cause: REACT_APP_BACKEND_URL was baked into the bundle but the host is unreachable from the browser.",
        "\nFix: leave REACT_APP_BACKEND_URL empty for production, or set it to the real prod backend URL, then redeploy."
      );
    }
    return Promise.reject(err);
  }
);

export const imageUrl = (storagePath) => {
  if (!storagePath) return "";
  return `${API}/files/${storagePath}`;
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  return String(detail);
};
